const ITEMS = [
    "Plumbers",
    "Electricians",
    "Builders",
    "Roofers",
    "Landscapers",
    "Mechanics",
    "Small Businesses",
];

export const Marquee = () => {
    const row = [...ITEMS, ...ITEMS];
    return (
        <div
            data-testid="trades-marquee"
            className="bg-zinc-950 border-y border-zinc-800 py-5 overflow-hidden select-none"
            aria-hidden="true"
        >
            <div className="marquee-track flex whitespace-nowrap w-max">
                {[0, 1].map((half) => (
                    <div key={half} className="flex">
                        {row.map((item, i) => (
                            <span
                                key={`${half}-${i}`}
                                className="flex items-center text-zinc-500 font-medium tracking-wide text-sm sm:text-base"
                                style={{ fontFamily: "Outfit, sans-serif" }}
                            >
                                <span className="px-6">{item}</span>
                                <span className="w-1.5 h-1.5 rounded-full bg-blue-600" />
                            </span>
                        ))}
                    </div>
                ))}
            </div>
        </div>
    );
};
